import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import Header from '../components/Header';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const AfterPayment = () => {
  return (
    <div>
    <Header/>
       <div>
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f9fafa"
    >
      <Paper
        elevation={3}
        sx={{
          width: '100%',
          maxWidth: 400,
          p: 4,
          textAlign: 'center',
          borderRadius: 2,
        }}
      >
        {/* Success Icon */}
        <div style={{marginBottom:'30px'}}>
       <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" /><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" /></svg>
       </div>

        {/* Payment Completed */}
        <Typography variant="h5" fontWeight="bold" color="success.main" mb={2}>
          Payment Completed <br /> Successfully
        </Typography>

        {/* Thank you for payment */}
        <Typography variant="body1" mb={3}>
          Thank you for your payment.
        </Typography>

        {/* Box for Message */}
        <Box
          bgcolor="#f0f7ff"
          p={2}
          mb={3}
          borderRadius={2}
          textAlign="left"
        >
          <Typography variant="body2" mb={1}>
            Your login credentials have been sent to your registered email address. Please check your inbox.
          </Typography>
          <Typography variant="body2" mb={1}>
            For your security, we recommend changing your password upon first login.
          </Typography>
          <Typography variant="body2">
            You can now access and manage your dashboard securely.
          </Typography>
        </Box>

        {/* Access Dashboard Button */}
       <a href='https://business.blaccdot.com/login' target='_blank' style={{textDecoration:'none'}}> <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ borderRadius: 1, py: 1.5, fontWeight: 'bold' }}
        >
          Access Dashboard
        </Button></a>
      </Paper>
    </Box>
    </div>
    </div>
  );
};

export default AfterPayment;



